import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Button,
  Input,
  Table,
  Spinner,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withRouter } from "react-router-dom"
import Select from "react-select"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import { isEmpty } from "lodash"
import ButtonSpinner from "components/ButtonSpinner"
import * as freeAction from "../../store/ZnJlZWxhbmNlclF1/actions"
import PropTypes from "prop-types"
import Modal from "react-bootstrap/Modal"
import moment from "moment"
import { MultiSelect } from "react-multi-select-component"
import api from "helpers/Api"

const FreelancerServicesList = (props) => {
  const { searchBtnStyle, dispatch } = props

  const title = "Freelancer Services List"

  // Get the current date
  const firstDayOfMonth = moment().startOf("month").format("YYYY-MM-DD")
  const lastDayOfMonth = moment().endOf("month").format("YYYY-MM-DD")

  const [freeData, setFreeData] = useState({
    eventFromDate: "",
    eventToDate: "",
  })

  //Fetching API
  useEffect(() => {
    setFreeData({
      ...freeData,
      eventFromDate: firstDayOfMonth,
      eventToDate: lastDayOfMonth,
    })
    dispatch(freeAction.loadRecordsMetaData())
    dispatch(
      freeAction.loadFreelancer({
        eventFromDate: firstDayOfMonth,
        eventToDate: lastDayOfMonth,
      })
    )
  }, [])

  //date format
  const update = useSelector(
    (specificstate) => specificstate.freelancerQuantityList
  )
  const [downloadLoading, setDownloadLoading] = useState(false)
  const { recordsMetaData = {}, free_data } = update
  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate

  const [branch, setBranch] = useState([])
  const [company, setCompany] = useState([])
  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormat = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  //Handle Change

  const [event, setEvent] = useState([])

  const handleChange = (e) => {
    setFreeData({ ...freeData, [e.target.name]: e.target.value })
  }

  //Search value
  const events = !isEmpty(event) && event.map((m) => m.value)
  const [searchFilter, setSearchFilter] = useState(false)
  const [searchInput, setSearchInput] = useState("")
  const [btnLoader, setBtnLoader] = useState(false)

  const branches = branch && branch.map((m) => m.value)

  const handleFilter = (e) => {
    e.preventDefault()

    var searchEvent = event && event ? events : ""
    var searchFromDate =
      freeData && freeData.eventFromDate
        ? moment(freeData.eventFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      freeData && freeData.eventToDate
        ? moment(freeData.eventToDate).format("YYYY-MM-DD")
        : ""
    var searchCompany = !isEmpty(company) && company ? company.value : ""
    var searchBranch = !isEmpty(branch) && branch ? branches : ""
    var searchvalue = {}

    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    dispatch(freeAction.loadFreelancer(searchvalue))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 3000)
  }

  //reset

  const resetForm = () => {
    setCompany([])
    setEvent([])
    setSearchInput("")
    setFreeData({
      ...freeData,
      leadNo: "",
      eventFromDate: firstDayOfMonth,
      eventToDate: lastDayOfMonth,
    })
    dispatch(
      freeAction.loadFreelancer({
        eventFromDate: firstDayOfMonth,
        eventToDate: lastDayOfMonth,
      })
    )
  }
  const [serviceDetailsDataSet, setServiceDetailsDataSet] = useState(false)
  const [serviceDetails, setServiceDetails] = useState("")
  const serviceTable = !isEmpty(free_data)
    ? free_data.map((data, index) => {
      if (
        !isEmpty(data) &&
        !isEmpty(data.services) &&
        data.services.length > 0 &&
        !serviceDetailsDataSet
      ) {
        setServiceDetails(data.services)
        setServiceDetailsDataSet(true)
      }

      return {
        _id: data._id,
        key: index,
        sNo: index + 1,
        date: data.date ? moment(data.date).format(dateFormat) : "--",
        total: data.total ? parseInt(data.total, 10) : "",
        service: !isEmpty(data.services) ? data.services : [],
        serviceCount: !isEmpty(data.services)
          ? data.services.map((m) => m.count)
          : "",
      }
    })
    : []

  const calculateColumnTotals = (tableData) => {
    return tableData.reduce((accumulator, data) => {
      if (!isEmpty(data.service) && data.service.length > 0) {
        Object.entries(data.service).forEach(([key, value]) => {
          const countAsNumber = parseInt(value.count, 10) || 0
          accumulator[key] = (accumulator[key] || 0) + countAsNumber
        })
      }

      const serviceAllAsNumber = parseInt(data.serviceAll, 10) || 0
      const totalAsNumber = parseInt(data.total, 10) || 0

      accumulator.serviceAll =
        (accumulator.serviceAll || 0) + serviceAllAsNumber
      accumulator.total = (accumulator.total || 0) + totalAsNumber

      return accumulator
    }, {})
  }

  const columnTotals =
    !isEmpty(serviceTable) && serviceTable.length > 0
      ? calculateColumnTotals(serviceTable)
      : {}

  console.log(serviceTable)
  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    dispatch(
      freeAction.loadFreelancer({
        searchFilter: searchInput,
        eventFromDate: firstDayOfMonth,
        eventToDate: lastDayOfMonth,
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = () => {
    var searchEvent = event && event ? events : ""
    var searchFromDate =
      freeData && freeData.eventFromDate
        ? moment(freeData.eventFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      freeData && freeData.eventToDate
        ? moment(freeData.eventToDate).format("YYYY-MM-DD")
        : ""
    var searchCompany = !isEmpty(company) && company ? company.value : ""
    var searchBranch = !isEmpty(branch) && branch ? branches : ""
    var searchvalue = {}

    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    setDownloadLoading(true)
    api
      .post(`/get_service_quantity_list_freelancer`, searchvalue)
      .then((response) => {
        const serviceExportDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((data, index) => {
            if (
              !isEmpty(data) &&
              !isEmpty(data.services) &&
              data.services.length > 0 &&
              !serviceDetailsDataSet
            ) {
              setServiceDetails(data.services)
              setServiceDetailsDataSet(true)
            }

            return {
              _id: data._id,
              key: index,
              sNo: index + 1,
              date: data.date ? moment(data.date).format(dateFormat) : "--",
              total: data.total ? parseInt(data.total, 10) : "",
              service: !isEmpty(data.services) ? data.services : [],
              serviceCount: !isEmpty(data.services)
                ? data.services.map((m) => m.count)
                : "",
            }
          })
          : []
        const columnTotals = {
          serviceCount: Array.from(
            { length: serviceExportDataTable[0]?.serviceCount.length || 0 },
            () => 0
          ),
          total: 0,
        }

        serviceExportDataTable.forEach((data) => {
          data.serviceCount.forEach((count, i) => {
            columnTotals.serviceCount[i] += count
          })
          columnTotals.total += data.total
        })
        setTimeout(() => {
          let headerData = [
            `SNo,Date${!isEmpty(serviceDetails) && serviceDetails.length > 0
              ? "," +
              serviceDetails.map((value) => value.serviceName).join(",")
              : ""
            },Total`,
          ]
          const totalRow = [
            "",
            "Total",
            ...columnTotals.serviceCount,
            columnTotals.total,
          ]
          let usersCsv = serviceExportDataTable.reduce((acc, user) => {
            const { sNo, date, serviceCount, total } = user
            acc.push([sNo, date, serviceCount, total])

            return acc
          }, [])

          downloadFile({
            data: [...headerData, ...usersCsv, totalRow].join("\n"),
            fileName: "FreelancerServicesList.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 1000)
        return response.data
      })
      .catch((error) => {
        Promise.reject(error)
        setDownloadLoading(false)
      })
  }
  const branchListOptions =
    !isEmpty(recordsMetaData) ?
      recordsMetaData.branchOptions.filter(
        (branch) => branch.companyId === company.value
      ) : []
  const handleCompany = (e) => {
    setCompany(e)
    setBranch([])
  }
  return (
    <div className="page-content">
      <MetaTags>
        <title>{title} | Zero Gravity CRM</title>
      </MetaTags>
      <Container fluid>
        <Breadcrumbs title={"Reports"} breadcrumbItem={title} />
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <form>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">Company</Label>

                      <Select
                        type="text"
                        name="company"
                        value={company}
                        onChange={(e) => handleCompany(e)}
                        options={
                          recordsMetaData ? recordsMetaData.companyOptions : []
                        }
                        placeholder="Select Company"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Branch"}
                        >
                          {"Branch"}
                        </Label>
                      </div>
                      <MultiSelect
                        options={branchListOptions}
                        value={branch}
                        onChange={setBranch}
                        labelledBy="Select"
                        hasSelectAll={true}
                      />
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Event From Date"}
                        >
                          {"Event From Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="eventFromDate"
                        value={freeData.eventFromDate}
                        max={freeData.eventToDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter "
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Event To Date"}
                        >
                          {"Event To Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="eventToDate"
                        value={freeData.eventToDate}
                        min={freeData.eventFromDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter "
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">Event</Label>
                      <Select
                        type="text"
                        name="event"
                        isMulti
                        value={event}
                        onChange={(e) => setEvent(e)}
                        options={
                          recordsMetaData ? recordsMetaData.eventOptions : []
                        }
                        placeholder="Select Event"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                      <div
                        className="filter-buttons"
                        style={{ float: "right" }}
                      >
                        <Button
                          type="button"
                          className="btn btn-danger btn-label simple-form-Reset-btn mx-3"
                          onClick={() => {
                            resetForm()
                          }}
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Reset
                        </Button>
                        <Button
                          type="submit"
                          onClick={(e) => handleFilter(e)}
                          className="btn btn-success btn-label simple-form-applyfilter-btn"
                        >
                          <i className="bx bx-filter-alt label-icon"></i>
                          {btnLoader && btnLoader ? (
                            <ButtonSpinner />
                          ) : (
                            "Apply Filter"
                          )}{" "}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md="12" lg="12" xl="12">
            <Card>
              <CardBody>
                <div className="d-flex flex-row" style={{ marginTop: "20px" }}>
                  <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                    <form onSubmit={handleClick} className="d-flex flex-row">
                      <div style={searchBtnStyle || null}>
                        <Input
                          type="text"
                          name="searchInput"
                          value={searchInput}
                          onChange={(e) => setSearchInput(e.target.value)}
                          className="form-control"
                          placeholder="Search"
                          style={{ position: "relative" }}
                        />
                        <i
                          className="bx bx-search-alt"
                          style={{
                            position: "absolute",
                            top: "54px",
                            left: "41px",
                            fontSize: "13px",
                          }}
                        />
                      </div>
                      <button
                        className="btn btn-success mx-2"
                        type="submit"
                        style={{
                          background: searchFilter ? "#2ca67a" : "",
                          color: searchFilter ? "#ffffff" : "",
                        }}
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </form>
                  </div>
                </div>{" "}
                <Row>
                  <Col md="4" lg="4" sm="12"></Col>
                  <Col
                    md="8"
                    lg="8"
                    sm="12"
                    style={{ marginBottom: "20px", marginTop: "-41px" }}
                  >
                    <div
                      style={{
                        float: "right",
                      }}
                    >
                      <Button
                        className="btn btn-primary"
                        onClick={exportToCsv}
                        id="download"
                        style={{
                          backgroundColor: "#e40d8c",
                          color: "white",
                          border: "none",
                        }}
                      >
                        Download
                      </Button>
                    </div>
                  </Col>
                </Row>
                <Col md="12" lg="12" xl="12">
                  <Table responsive bordered onScroll={true}>
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Date</th>
                        {!isEmpty(serviceDetails) && serviceDetails.length > 0
                          ? Object.entries(serviceDetails).map(
                            ([key, value]) => {
                              const total =
                                columnTotals && !isEmpty(columnTotals)
                                  ? columnTotals[key]
                                  : ""
                              if (total != 0) {
                                return (
                                  <th
                                    style={{
                                      minWidth: "230px",
                                    }}
                                    key={key}
                                  >
                                    {value.serviceName}
                                  </th>
                                )
                              }
                            }
                          )
                          : []}

                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!isEmpty(serviceTable) && serviceTable.length > 0 ? (
                        serviceTable.map((data, index) => {
                          return (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{data.date}</td>
                              {!isEmpty(data.service) && data.service.length > 0
                                ? Object.entries(data.service).map(
                                  ([key, value]) => {
                                    const total =
                                      columnTotals && !isEmpty(columnTotals)
                                        ? columnTotals[key]
                                        : ""
                                    if (total != 0) {
                                      return (
                                        <td
                                          style={{
                                            minWidth: "140px",
                                          }}
                                          key={key}
                                        >
                                          {value.count}
                                        </td>
                                      )
                                    }
                                  }
                                )
                                : ""}

                              <td>{data.total}</td>
                            </tr>
                          )
                        })
                      ) : (
                        <tr>
                          <td
                            className="text-align-center"
                            colSpan={serviceDetails.length + 4}
                          >
                            No Records Found...
                          </td>
                        </tr>
                      )}
                      {!isEmpty(serviceTable) && serviceTable.length > 0 ? (
                        <tr>
                          <td></td>
                          <td
                            style={{
                              backgroundColor: "#3abd856e",
                              borderRight: "1px solid #e1e1e1",
                              borderBottom: "1px solid #e1e1e1",
                              fontWeight: "450",
                            }}
                          >
                            Total
                          </td>
                          {!isEmpty(serviceDetails) && serviceDetails.length > 0
                            ? Object.entries(serviceDetails).map(([key]) => {
                              const total =
                                columnTotals && !isEmpty(columnTotals)
                                  ? columnTotals[key]
                                  : ""
                              // console.log(total, "total")
                              if (total != 0) {
                                return (
                                  <td
                                    style={{
                                      backgroundColor: "#3abd856e",
                                      borderRight: "1px solid #e1e1e1",
                                      borderBottom: "1px solid #e1e1e1",
                                      fontWeight: "450",
                                    }}
                                    key={key}
                                  >
                                    {columnTotals[key] || 0}
                                  </td>
                                )
                              }
                            })
                            : []}

                          <td
                            style={{
                              backgroundColor: "#3abd856e",
                              borderRight: "1px solid #e1e1e1",
                              borderBottom: "1px solid #e1e1e1",
                              fontWeight: "450",
                            }}
                          >
                            {columnTotals.total || 0}
                          </td>
                        </tr>
                      ) : (
                        ""
                      )}
                    </tbody>
                  </Table>
                  <div className="font-size-14 mt-2">
                    <p>{`Showing rows ${free_data && free_data.length > 0 ? 1 : 0
                      } to ${free_data && free_data.length > 0 ? free_data.length : 0
                      } of ${free_data && free_data.length > 0 ? free_data.length : 0
                      }`}</p>
                  </div>
                </Col>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      {downloadLoading ? (
        <Modal
          show={downloadLoading}
          style={{ width: "7%", margin: "18% 50%" }}
        >
          <Modal.Body>
            <Spinner
              as="span"
              animation="grow"
              size="lg"
              role="status"
              aria-hidden="true"
              variant="success"
              className="mx-2"
              color="success"
            />
          </Modal.Body>
        </Modal>
      ) : (
        ""
      )}
    </div>
  )
}
FreelancerServicesList.propTypes = {
  dispatch: PropTypes.func,
  searchBtnStyle: PropTypes.any,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FreelancerServicesList)
)
